import { TenantJob } from '~/tenants/common/TenantJob';
import { PicOrderContext, PicPerformableConfig } from '~/tenants/pic/model/PicOrder';

export default abstract class PicJob<P extends PicPerformableConfig> extends TenantJob<PicOrderContext, P> {}
